import request from '@/utils/request'


//所有客服列表
export function CustomerService(params) {
  return request({
    url: '/kxkefu/info/CustomerService',
    method: 'get',
    params: params
  })
}

//聊天记录
export function historyRecord(params) {
  return request({
    url: '/kxkefu/chat/historyRecord',
    method: 'get',
    params: params
  })
}

//获取当前用户信息
export function getUserInfo(params) {
  return request({
    url: '/kxkefu/info/user',
    method: 'get',
    params: params
  })
}


//获取当前在线人数
export function onlineUsers(params) {
  return request({
    url: '/kxkefu/info/onlineUsers',
    method: 'get',
    params: params
  })
}


//当前用户浏览记录
export function historyViews(params) {
  return request({
    url: '/kxkefu/info/recording',
    method: 'get',
    params: params
  })
}


//删除聊天记录
export function DeleteChat(data) {
  return request({
    url:'/kxkefu/chat/news/delete',
    method:'post',
    data:data
  })
}


//撤回聊天记录
export function RevokeChat(data) {
  return request({
    url:'/kxkefu/chat/news/revoke',
    method:'post',
    data:data
  })
}


//图片上传
export function uploadChatImg(data) {
  return request({
    // url: '/kxuser/user/uploadUserAvatar/chat',
    url: 'kxkefu/chat/uploadImage',
    method: 'post',
    data: data,
    headers: {
      "Content-Type": "multipart/form-data;charset=utf-8"
    },
  })
}

//提交留言
export function sendChat(data) {
  return request({
    url:'/kxkefu/chat/chat',
    method:'post',
    data:data
  })
}

//24小时留言过用户列表
export function onlineList(params) {
  return request({
    url: '/kxkefu/info/onlineList',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/kefu.js